// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0301cfdc]:export{primaryColor:#64b5f6;secondaryColor:#003c60;accentColor:#c41230}.tc-number[data-v-0301cfdc]{margin:0 0 0 4px}.v-footer[data-v-0301cfdc]{color:#000}.logo[data-v-0301cfdc]{max-height:150px}.terms-and-conditions[data-v-0301cfdc]{font-size:13.2px}.logo-jakafi[data-v-0301cfdc]{width:171px;height:66px}", ""]);
// Exports
module.exports = exports;
